import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FadeUp } from '../components/Motion';
import { MapPin, CalendarDays, Languages, ArrowRight } from 'lucide-react';

export default function Visit() {
  const { t } = useTranslation();
  return (
    <main data-testid="visit-page" className="pt-32">
      <section className="relative h-[60vh] overflow-hidden">
        <img src="https://customer-assets.emergentagent.com/job_climate-resilience-5/artifacts/dnx18t6i_IMG_7093.jpeg" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/40 to-transparent" />
        <div className="relative h-full container-x max-w-7xl mx-auto flex items-end pb-16">
          <FadeUp>
            <p className="overline text-sun">{t('visit.overline')}</p>
            <h1 className="mt-3 font-heading text-5xl sm:text-6xl lg:text-7xl text-bone tracking-tight max-w-3xl">{t('visit.title')}</h1>
          </FadeUp>
        </div>
      </section>

      <section className="container-x max-w-7xl mx-auto py-20 grid gap-12 lg:grid-cols-12">
        <FadeUp className="lg:col-span-7">
          <p className="text-lg text-ink-soft leading-relaxed">{t('visit.intro')}</p>
        </FadeUp>
        <FadeUp delay={0.1} className="lg:col-span-5">
          <div className="bg-white border border-border-soft rounded-3xl p-8">
            <h3 className="font-heading text-2xl text-ink mb-6">{t('visit.info_title')}</h3>
            <ul className="grid gap-5">
              <li className="flex items-start gap-4">
                <MapPin className="text-forest mt-1 shrink-0" size={20} />
                <div>
                  <p className="overline mb-1">{t('visit.location')}</p>
                  <p className="text-ink-soft">{t('visit.location_v')}</p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <CalendarDays className="text-forest mt-1 shrink-0" size={20} />
                <div>
                  <p className="overline mb-1">{t('visit.when')}</p>
                  <p className="text-ink-soft">{t('visit.when_v')}</p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <Languages className="text-forest mt-1 shrink-0" size={20} />
                <div>
                  <p className="overline mb-1">{t('visit.languages')}</p>
                  <p className="text-ink-soft">{t('visit.languages_v')}</p>
                </div>
              </li>
            </ul>
            <Link to="/contact" className="mt-8 btn-primary w-full" data-testid="visit-cta">
              {t('visit.cta')} <ArrowRight size={18} />
            </Link>
          </div>
        </FadeUp>
      </section>
    </main>
  );
}
